import { firebaseDatabase, firebaseAuth, firestorage } from '../utils/firebase'
import firebase from 'firebase';
import { BehaviorSubject } from 'rxjs';


const getCurrentUser = () => {
    return firebaseAuth.currentUser ?? JSON.parse(localStorage.getItem('user'));
};

const currentUser = new BehaviorSubject(getCurrentUser());

const FirebaseService = {

    login: async (email, password) => {
        let loginData = await firebaseAuth.signInWithEmailAndPassword(email, password)
        localStorage.setItem('user', JSON.stringify(loginData.user));
        currentUser.next(loginData.user);
        return loginData.user;
    },

    logout: async () => {
        if (!getCurrentUser().isAnonymous) {
            localStorage.removeItem('user')
            currentUser.next({})
            return firebaseAuth.signOut()
            .then(() => firebaseAuth.signInAnonymously())
            .then(data => {
                localStorage.setItem('user', JSON.stringify(data.user));
                currentUser.next(data.user);
            })
        }
    },

    loginAsAnonymous: () => {
        return firebaseAuth.signInAnonymously();
    },

    currentUser: currentUser,

    getCurrentUser: getCurrentUser,

    getConfig: (config) => {
        return firebaseDatabase.collection('config').doc(config).get();
    },

    getFile: (filename) => {
        return firestorage.ref(filename).getDownloadURL();
    },

    getUserData: (id) => {
        const collection = firebaseDatabase.collection('users').doc(id);
        return collection.get();
    },

    getChatMessages: (id, page = 1, callback) => {
        let limit = 60 * page;
        const collection = firebaseDatabase.collection('chats')
            .doc(id).collection('messages')
            .orderBy('timestemp', 'desc').limit(limit);
        return collection.onSnapshot(callback);
    },

    
    subscribeLastChatMessage: (id, callback) => {
        const collection = firebaseDatabase.collection('chats').doc(id).collection('messages').orderBy('timestemp', 'desc');
        return collection.onSnapshot(callback);
    },

    getMeetingList: () => {
        const today = new Date();
        today.setMinutes(today.getMinutes() - 60);
        let data = firebase.firestore.Timestamp.fromDate(today);

        const meetingsCollection = firebaseDatabase.collection('meetings')
            .where('date', '>', data)
            .orderBy('date');
        return meetingsCollection.get();
    },

    setMeeting: (data) => {
        let doc;

        if (!data.id) {
            doc = firebaseDatabase.collection('meetings').doc();
            return doc.set({
                id: doc.id,
                addictionId: data.addictionId,
                admin: data.admin,
                date: firebase.firestore.Timestamp.fromDate(data.date),
                status: 'active',
                limit: data.limit,
                link: data.link,
                users: []
            })
        } else {
            return firebaseDatabase.collection('meetings').doc(data.id).update({
                addictionId: data.addictionId,
                admin: data.admin,
                date: firebase.firestore.Timestamp.fromDate(data.date),
                limit: data.limit,
                link: data.link,
            });
        }

    },

    getAdmins: () => {
        const collection = firebaseDatabase.collection('admins');

        return collection.get();
    },

    getAddicts: () => {
        const collection = firebaseDatabase.collection('addictions');
        return collection.get();
    },

    getAccount: (id) => {
        return firebaseDatabase.collection('accounts').doc(id).get();
    },

    subscribeAccount: (callback) => {
        if (getCurrentUser()?.uid) {
            const collection = firebaseDatabase.collection('accounts').doc(getCurrentUser().uid);
            return collection.onSnapshot(callback);
        }
    },

    createChatMessage: (chatId, message) => {
        return firebaseDatabase.collection('chats').doc(chatId).collection('messages').add(message).then(ref => {
            message.id = ref.id;
            return ref.update({id: ref.id})
        });
    },

    updateContact: (uid, chatId, data) => {
        return firebaseDatabase.collection('users').doc(uid).collection('contacts').doc(chatId).update(data);
    },

    updateContactAccountData: (uid, data) => {
        return firebaseDatabase.collection('accounts').doc(uid).update(data);
    },

    subscribeContacts: async (callback) => {
        const account = (await firebaseDatabase.collection('accounts').doc(getCurrentUser().uid).get()).data();
        return firebaseDatabase.collection('users').doc(account.id).collection('contacts')
            .where('status', '==', 'active')
            .orderBy('lastMessage', 'desc')
            .onSnapshot(callback);
    },

    findContacts: (name) => {
        return firebaseDatabase.collection('users').orderBy("name").startAt(name).endAt(name+"\uf8ff");
    },

    updateAccount: (account) => {
        if (getCurrentUser()?.uid) {
            const collection = firebaseDatabase.collection('accounts').doc(getCurrentUser().uid);
            return collection.update({
                status: account.status
            });
        }
    },

}

export default FirebaseService;